import { useMemo } from "react";
import { findTrackedBrandsInText } from "../../blindQuerySafety";

interface LeakCheckArgs {
  /** Whether blind-query mode is active. When false, no leak is reported. */
  enabled: boolean;
  /** The prompt template text to scan (null when no prompt is selected). */
  promptTemplate: string | null | undefined;
  /** Names of the currently selected tracked brands. */
  brandNames: string[];
}

interface LeakCheckResult {
  /** Selected tracked brand names that appear in the prompt text. */
  brandNamesInPrompt: string[];
  /** True when blind query is enabled and at least one tracked brand leaks into the prompt. */
  hasLeak: boolean;
}

/**
 * Detects whether selected tracked brand names leak into a blind-query prompt.
 * Shared by Compare, Report, and Study creation flows.
 */
export function useBlindQueryLeakCheck({ enabled, promptTemplate, brandNames }: LeakCheckArgs): LeakCheckResult {
  return useMemo(() => {
    const brandNamesInPrompt =
      enabled && promptTemplate
        ? findTrackedBrandsInText(promptTemplate, brandNames.map((name) => ({ name })))
        : [];
    return { brandNamesInPrompt, hasLeak: enabled && brandNamesInPrompt.length > 0 };
  }, [enabled, promptTemplate, brandNames]);
}
